module.exports = __webpack_public_path__ + "img/1537.2f8498dd.gif";